import axios from 'axios';

import * as t from '../types';

export const AddFavory = id => async (dispatch, getState) => {
  const token = getState().auth.data.access_token;

  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Bearer ` + token,
  };
  await axios
    .post(
      `${process.env.REACT_APP_API}/api/favories`,
      { restaurant_id: id },
      { headers }
    )
    .then(res => {
      //   (res);
    })
    .catch(err => {
      //   (err);
    });

  //   (data);
};
export const getFavories = id => async (dispatch, getState) => {
  const token = getState().auth.data.access_token;
  //   (token);

  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Bearer ` + token,
  };

  await axios
    .get(`${process.env.REACT_APP_API}/api/favories`, { headers })
    .then(res => {
      //   (res);
      dispatch({ type: t.GET_FAVORIES, payload: res.data });
    })
    .catch(err => {
      console.log(err);
    });

  //   (data);
};
export const deleteFavory = id => async (dispatch, getState) => {
  const token = getState().auth.data.access_token;
  const favs = getState().rest.favs;
  //   ('favs', favs);

  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Bearer ` + token,
  };

  await axios
    .delete(`${process.env.REACT_APP_API}/api/favories/${id}`, { headers })
    .then(res => {
      //   (res);
      const newFavs = favs.filter(fav => fav.favory_id !== id);
      //   (newFavs);

      dispatch({ type: t.DELETE_FAVORY, payload: newFavs });
    })
    .catch(err => {
      console.log(err);
    });

  //   (data);
};
export const getFilters = filters => async (dispatch, getState) => {
  //   (filters);

  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
  if (filters.distance) {
    await axios
      .post(
        `${process.env.REACT_APP_API}/api/nearest?apiKey=${filters.apiKey}&&distance=${filters.distance}&&longitude=${filters.longtitude}&&latitude=${filters.latitude}&&limit=10`,
        headers
      )
      .then(res => {
        dispatch({ type: t.GET_FILTERS, payload: res.data });
      })
      .catch(err => {
        console.log(err);
      });

    // (data);
  } else {
    dispatch({ type: t.CLEAR_FILTERS });
  }
};

export const getRestaurants = () => async (dispatch, getState) => {
  dispatch({ type: t.REST_LOADING });
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
  const location = getState().location;

  await axios
    .get(
      `${process.env.REACT_APP_API}/api/restaurants?apiKey=azerty&limit=10&distance=1000&latitude=${location.latitude}&longtitude=${location.longtitude}&offset=0`,
      {
        headers,
      }
    )
    .then(res => {
      dispatch({ type: t.GET_RESTAURANTS, payload: res.data });
    })
    .catch(err => {
      console.log(err);
    });

  //   (data);
};
export const getRestaurant = id => async (dispatch, getState) => {
  dispatch({ type: t.REST_LOADING });
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };

  await axios
    .get(`${process.env.REACT_APP_API}/api/restaurants/${id}`, {
      headers,
    })
    .then(res => {
      dispatch({ type: t.GET_RESTAURANT, payload: res.data });
    })
    .catch(err => {
      console.log(err);
    });

  //   (data);
};
export const getCategories = () => async (dispatch, getState) => {
  dispatch({ type: t.REST_LOADING });
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };

  await axios
    .get(`${process.env.REACT_APP_API}/api/allCategories`, {
      headers,
    })
    .then(res => {
      dispatch({ type: t.GET_CATEGORIES, payload: res.data });
    })
    .catch(err => {
      console.log(err);
    });

  //   (data);
};

// export async function getStaticProps() {
//   // Call an external API endpoint to get posts.
//   // You can use any data fetching library
//   const res = await fetch(
//     `${process.env.REACT_APP_API}/api/restaurants?apiKey=azerty&limit=50&offset=0`
//   );
//   const catres = await fetch(`${process.env.REACT_APP_API}/api/allCategories`);
//   const posts = await res.json();
//   const cat = await catres.json();
//   //   (cat);

//   // By returning { props: posts }, the Blog component
//   // will receive `posts` as a prop at build time
//   return {
//     props: {
//       posts,
//       cat,
//     },
//   };
// }
